import React from 'react';
import PropTypes from 'prop-types';
import { SlideGroupContextProvider } from '../../../components/SlideManager';
import { DateField } from '../MobileFields';
import { SegmentHeaderMobile } from './SegmentHeaderMobile';
import { ConnectedFlightsManagerLegMobile } from '../FlightsManagerLegMobile';
import { ConnectedFaresProvider } from '../../../components/Calendar/Context/FaresProvider';

export const SegmentMobileContent = ({ id, index, totalSegments, displayFaresInCalendar }) => {
    return (
        <React.Fragment>
            <SegmentHeaderMobile index={index} totalSegments={totalSegments} />
            <div>
                <ConnectedFlightsManagerLegMobile id={id} index={index} />
                <ConnectedFaresProvider segmentId={id} displayFaresInCalendar={displayFaresInCalendar}>
                    <DateField />
                </ConnectedFaresProvider>
            </div>
        </React.Fragment>
    );
};

SegmentMobileContent.propTypes = {
    id: PropTypes.number.isRequired,
    index: PropTypes.number.isRequired,
    totalSegments: PropTypes.number.isRequired,
    displayFaresInCalendar: PropTypes.bool.isRequired,
};

export const SegmentMobile = ({ id, index, totalSegments, displayFaresInCalendar }) => {
    return (
        <React.Fragment>
            { totalSegments === 1 ? (
                <SegmentMobileContent
                    id={id}
                    index={index}
                    totalSegments={totalSegments}
                    displayFaresInCalendar={displayFaresInCalendar}
                />
            ) : (
                <SlideGroupContextProvider>
                    <SegmentMobileContent
                        id={id}
                        index={index}
                        totalSegments={totalSegments}
                        displayFaresInCalendar={displayFaresInCalendar}
                    />
                </SlideGroupContextProvider>
            )}
        </React.Fragment>
    );
};

SegmentMobile.propTypes = {
    id: PropTypes.number.isRequired,
    index: PropTypes.number.isRequired,
    totalSegments: PropTypes.number.isRequired,
    displayFaresInCalendar: PropTypes.bool.isRequired,
};
